import { Component, OnInit } from '@angular/core';
import {InstallImages} from '../webData';
@Component({
  selector: 'app-install',
  templateUrl: './install.component.html',
  styleUrls: ['./install.component.css']
})
export class InstallComponent implements OnInit {

  images: any;

  constructor() {}

  ngOnInit() {
    this.images = InstallImages;
    console.log(this.images);
  }

}



// WEBPACK FOOTER //
// /Users/samirjha/Project/nushing/src/app/install/install.component.ts